import React from 'react';

import { TextField } from '@occc-app/design-system';

const getInputProps = (inputName: string) => ({
  'data-testid': `campaign-form-field-${inputName}`,
});

const nameInputProps = getInputProps('name');
const descriptionInputProps = getInputProps('description');
const categoryInputProps = getInputProps('category');
const externalIdInputProps = getInputProps('externalId');

export const FormContent: React.FC = () => {
  return (
    <>
      <TextField
        name='name'
        label='Name'
        required={true}
        inputProps={nameInputProps}
        margin='normal'
        sx={{ mt: 0 }}
      />
      <TextField
        name='description'
        label='Description'
        multiline={true}
        inputProps={descriptionInputProps}
        margin='normal'
      />
      <TextField name='category' label='Category' inputProps={categoryInputProps} margin='normal' />
      <TextField
        name='externalId'
        label='External Id'
        inputProps={externalIdInputProps}
        margin='normal'
        sx={{ mb: 0 }}
      />
    </>
  );
};
